window.App = {
    W: $(window),
    D: $(document),
    H: $('html'),
    B: $('body'),
    ie: false,
    edge: false,
    firefox: false,
    mainpage: false,
    ru: false,
    tabletH: 1024,
    tabletV: 768
};


// Классы страницы
{

    if (App.H.hasClass('mobile')) {
        App.mobile = true;
    } else {
        App.H.addClass('desktop');
    }

    if (App.H.hasClass('ie')) {
        App.ie = true;
    }

    if (App.H.hasClass('edge')) {
        App.edge = true;
    }

    if (App.H.hasClass('firefox')) {
        App.firefox = true;
    }

    if (App.H.hasClass('page-main')) {
        App.mainpage = true;
    }

    if (App.H.attr('lang') == 'ru') {
        App.ru = true;
    }
}



// WEBPACK FOOTER //
// ./_src/js/App.js